var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _c(
        "vue-folder-button",
        {
          directives: [
            {
              name: "touch",
              rawName: "v-touch:touchhold",
              value: _vm.showLikePopover,
              expression: "showLikePopover",
              arg: "touchhold",
            },
          ],
          ref: "likeButton",
          attrs: {
            text: _vm.likeButtonText,
            color: _vm.likeButtonColor,
            tabindex: "0",
            "icon-class": "fa-heart",
          },
          nativeOn: {
            mousedown: function ($event) {
              $event.stopPropagation()
              return _vm.toggleLike.apply(null, arguments)
            },
            mouseenter: function ($event) {
              return _vm.showLikePopoverWithDelay.apply(null, arguments)
            },
            mouseleave: function ($event) {
              return _vm.cancelShowLikePopover.apply(null, arguments)
            },
          },
        },
        [
          _c("span", {
            attrs: { slot: "text" },
            domProps: { innerHTML: _vm._s(_vm.likeButtonText) },
            slot: "text",
          }),
        ]
      ),
      _vm._v(" "),
      _vm.popoverReady
        ? _c(
            "Popover",
            {
              ref: "likeButtonPopover",
              attrs: {
                "custom-class": "like-button-popover",
                title: "Liked by:",
                trigger: "manual",
                placement: "bottom",
                target: _vm.$refs.likeButton,
                tabindex: "0",
              },
              model: {
                value: _vm.likePopoverOpened,
                callback: function ($$v) {
                  _vm.likePopoverOpened = $$v
                },
                expression: "likePopoverOpened",
              },
            },
            [
              _c("template", { slot: "popover" }, [
                _c(
                  "div",
                  _vm._l(_vm.entry.liked_users_sample, function (likedUser) {
                    return _c(
                      "simple-link",
                      { key: likedUser.id, attrs: { target: likedUser } },
                      [
                        _c("span", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: likedUser.name,
                              expression: "likedUser.name",
                            },
                          ],
                          staticClass: "liked-users-sample",
                          style: _vm.getLikedUserSampleStyle(likedUser),
                        }),
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _vm.entry.likes_count > 5
                  ? _c("div", { staticClass: "text-right" }, [
                      _c(
                        "span",
                        {
                          staticClass: "text-right color-tag-gray-dark pointer",
                          on: { click: _vm.showWhoLiked },
                        },
                        [_vm._v("Show more")]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }